import styled from 'styled-components';

export const TextLabel = styled.span`

`;